import auth from "./authenticationModule";
import ui from "./uiModule";
import { ModuleTree } from "vuex";
import { RootState } from "..";

var modules: ModuleTree<RootState> = {};

export { modules, auth, ui };
